import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchUserManagementCompany = createAsyncThunk("fetchUserManagementCompany", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.userManagementCompany}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.userManagementCompany} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchUserManagementIndustry = createAsyncThunk("fetchUserManagementIndustry", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.userManagementIndustry}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.userManagementIndustry} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchUsersList = createAsyncThunk("fetchUsersList", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.userManagementList}?search=${data.search}&page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&companyId=${data?.companyId}&industryType=${data?.industryType}${data.getPendingOnly ? `&getPendingOnly=${data?.getPendingOnly}`:""}`);
  if (response?.status === 200 || response?.status === 400) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.userManagementList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualUser = createAsyncThunk("fetchIndividualUser", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualUser}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.individualUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchUserCreditHistory = createAsyncThunk("fetchUserCreditHistory", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.userCreditHistory}?user_id=${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.userCreditHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchUserPurchaseHistory = createAsyncThunk("fetchUserPurchaseHistory", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.userPurchaseHistory}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.userPurchaseHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const deleteUser = createAsyncThunk("deleteUser", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().delete(`${API_END_POINTS.deleteUser}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.deleteUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const updateUserStatus = createAsyncThunk("updateUserStatus", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.userStatusChange}/${data.status}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.userStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editUser = createAsyncThunk("editUser", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editUser}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});


 export const userManagementSlice = createSlice({
  name: "userManagement",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(fetchUserManagementCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUserManagementCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUserManagementCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchUserManagementIndustry.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUserManagementIndustry.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUserManagementIndustry.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchUsersList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUsersList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUsersList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchUserCreditHistory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUserCreditHistory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUserCreditHistory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchUserPurchaseHistory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchUserPurchaseHistory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchUserPurchaseHistory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(updateUserStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateUserStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateUserStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });

  },
});

export default userManagementSlice.reducer;
